<h2 class="govuk-heading-m">{{ heading() }}</h2>

<cca-dashboard-filters />

@if (!state().isLoading) {
  <div class="x-scroll">
    <div class="max-content-width">
      <cca-dashboard-items-list [items]="state().items" [tableColumns]="tableColumns()" />
    </div>
  </div>

  <cca-pagination
    [count]="state().totalItems"
    [currentPage]="currentPage()"
    [pageSize]="pageSize()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  />
}
